import axios from 'axios';
import { getAccessToken } from '../../utils/Accounts';
import { configuredStore } from '../../redux/';
import { doLogout } from '../../redux/thunks/authentication';

const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_APP_BASE_API_URL}/`,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

const axiosInfraInstance = axios.create({
  baseURL: `${import.meta.env.VITE_APP_INFRA_API_URL}/`,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

const axiosSaamsInstance = axios.create({
  baseURL: `${import.meta.env.VITE_APP_SAAMS_API_URL}/`,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

axiosInstance.interceptors.request.use(
  async function (config) {
    try {
      const token = await getAccessToken();
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    } catch (error) {
      configuredStore.store.dispatch(doLogout("User session expired!"));
    }
  },
  function (error) {
    return Promise.reject(error);
  },
);

axiosInfraInstance.interceptors.request.use(
  async function (config) {
    try {
      const token = await getAccessToken();
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    } catch (error) {
      configuredStore.store.dispatch(doLogout("User session expired!"));
    }
  },
  function (error) {
    return Promise.reject(error);
  },
);

axiosSaamsInstance.interceptors.request.use(
  async function (config) {
    try {
      const token = await getAccessToken();
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    } catch (error) {
      configuredStore.store.dispatch(doLogout("User session expired!"));
    }
  },
  function (error) {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    return Promise.reject(error);
  },
);

axiosInfraInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    return Promise.reject(error);
  },
);

axiosSaamsInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    return Promise.reject(error);
  },
);

export { axiosInstance, axiosInfraInstance, axiosSaamsInstance };
